import { render, staticRenderFns } from "./cashAdvances.vue?vue&type=template&id=8636b180&scoped=true&"
import script from "./cashAdvances.vue?vue&type=script&lang=js&"
export * from "./cashAdvances.vue?vue&type=script&lang=js&"
import style0 from "./cashAdvances.vue?vue&type=style&index=0&id=8636b180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8636b180",
  null
  
)

export default component.exports